export const FANDATA = {
  columnDefinitions: [
    {
      caption: 'Foundation accounts using this profile:', field: 'fanId', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
      enableSorting: true, enableFilter: true, cssClass: '', priority: 1, customTemplate: 'callBackAppNameCellTemplate'
    }
  ],
  pageDetails: {
    'heading1': 'Deployment profile: ',
    'heading2': 'Settings',
    'newDevices': 'Network access control for new devices:  ',
    'existingDevices': 'Network access control for existing devices:  ',
    'noDateSetLabel': 'Not set',
    'security': 'Security policy:',
    'passcode': 'Passcode policy:',
    'notification': 'Send notification by:',
    'enrollment': 'Auto-enrollment: ',
    'newDeviceDate': 'New device enrollment date:',
    'existDeviceDate': 'Existing device enrollment date:',
    'subHeading': 'Applications',
    'profile' : 'Deployment profile:',
    'mdmServiceHeading': 'Device management service',
    'mdmService': 'Type: ',
    'profileName': 'Profile Name:',
    'supportArticle1': 'Support article 1',
    'supportArticle2': 'Support article 2',
    'supportArticle3': 'Support article 3',
    'oemDetailsKme': 'Knox Mobile Enrollment ID:',
    'oemDetailsZtp': 'Android™ zero-touch account ID:',
    'mdmServiceIbm': 'IBM MaaS 360<sup>®</sup> lite',
    'mdmServiceZtp': 'Android™',
    'mdmServiceKme': 'Samsung Knox Mobile Enrollment'
  }
};
